var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9908 7.65132V7.6066C23.9908 3.57552 21.5476 1.20117 17.413 1.20117H6.57892C2.44323 1.20117 0 3.57552 0 7.6066V16.3864C0 20.4175 2.44323 22.8012 6.57892 22.8012H17.4172C21.5519 22.8012 23.9951 20.4175 23.9951 16.3864V16.0193H18.9103C16.5406 16.0161 14.6231 14.14 14.6263 11.8291C14.6306 9.52334 16.546 7.65548 18.9103 7.65132H23.9908Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69521 7.64247H12.4618H12.4661H12.4746C12.9812 7.64039 13.3907 7.23791 13.3886 6.74286C13.3864 6.24885 12.9727 5.84949 12.4661 5.85157H5.69521C5.19184 5.85365 4.78339 6.25197 4.78126 6.7439C4.77913 7.23791 5.18864 7.64039 5.69521 7.64247ZM16.8496 12.358C17.1005 13.4994 18.101 14.3025 19.2433 14.2816H23.1424C23.6177 14.2816 24.0032 13.8879 24.0032 13.4012V10.3634C24.0022 9.87777 23.6177 9.48303 23.1424 9.48199H19.1515C17.8521 9.48616 16.8027 10.5649 16.8047 11.8943C16.8047 12.0499 16.82 12.2055 16.8496 12.358ZM20.3995 11.882C20.3995 12.5448 19.8624 13.082 19.1998 13.082C18.5371 13.082 18 12.5448 18 11.882C18 11.2193 18.5371 10.682 19.1998 10.682C19.8624 10.682 20.3995 11.2193 20.3995 11.882Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet2);
export default __webpack_public_path__ + "static/media/wallet2.e2253c1e63de3a06fa437ec2e1f32f96.svg";
export { ForwardRef as ReactComponent };